import createReducer from 'utils/redux/createReducer'
import * as R from 'ramda'

const initialState = {

}
export default createReducer(initialState, {
	TOGGLE_TOOLTIP: (currentState, action) => ({
		...R.map(x => false)(currentState)
	  , [action.data]: currentState[action.data] ? !currentState[action.data] : true
	})
  , CLOSE_TOOLTIP: (currentState, action) => ({
		...currentState
	  , [action.data]: false
	})
  , CLOSE_ALL_TOOLTIPS: (currentState, action) => ({
		...R.map(x => false)(currentState)
	})
  , '@@router/LOCATION_CHANGE': (currentState, action) => ({
		...R.map(x => false)(currentState)
	})
})



// WEBPACK FOOTER //
// ./src/reducers/tooltips.js